import request from '@/utils/request'

const baseApi = process.env.VUE_APP_PURCHASE_API

// 查询项目信息
export function getReviewProjectInSupplierApi(projectId) {
  return request({
    url: baseApi + `/review-hall/supplier/kpb/projects/${projectId}`,
    method: 'get'
  })
}

/* *** 投标人报价相关接口 *** */
// 查询评标报价单
export function getQuoteOfferInSupplierApi(projectId) {
  return request(
    {
      url:
        baseApi +
        `/review-hall/supplier/kpb/projects/${projectId}/review-offer`,
      method: 'get'
    },
    false
  )
}

// 查询报价轮次列表
export function getQuoteRoundListInSupplierApi(projectId, offerId) {
  return request(
    {
      url:
        baseApi +
        `/review-hall/supplier/kpb/projects/${projectId}/review-offer/${offerId}/offer-rounds`,
      method: 'get'
    },
    false
  )
}

// 查询自己的报价列表
export function getQuoteHistoryListInSupplierApi(projectId, bidderId, offerId) {
  return request(
    {
      url:
        baseApi +
        `/review-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/review-offer/${offerId}/offers`,
      method: 'get'
    },
    false
  )
}

// 提交自己的报价
export function postQuoteInSupplierApi(projectId, bidderId, offerId, data) {
  return request({
    url:
      baseApi +
      `/review-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/review-offer/${offerId}/offers`,
    method: 'post',
    data
  })
}

/* *** 投标人询标相关接口 *** */
// 分页查询询标-消息列表
export function getInquiryMessageListInSupplierApi(
  projectId,
  bidderId,
  params
) {
  return request(
    {
      url:
        baseApi +
        `/review-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/review-asks/page`,
      method: 'get',
      params
    },
    false
  )
}

// 回复评审专家的询标信息
export function postInquiryMessageInSupplierApi(projectId, bidderId, data) {
  return request(
    {
      url:
        baseApi +
        `/review-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/review-asks/reply-ask`,
      method: 'post',
      data
    },
    false
  )
}

// 查询投标人信息
export function getBidderInfoApi(projectId, bidderId) {
  return request({
    url: baseApi + `/workbench/supplier/kpb/projects/${projectId}/bidders/${bidderId}`,
    method: 'get'
  })
}
